import template from './advertInlineList.html';
import controller from './advertInlineList.controller';
import './advertInlineList.scss';

let advertInlineListComponent = {
  restrict: 'E',
  bindings: {
    adverts: '<',
    locations: '<',
    nonRacingEvents: '<',
    changeState: '&'
  },
  template,
  controller
};

export default advertInlineListComponent;
